<template>
  <div class="w-full text-left">
    <div class="mb-5">
      <h2 class="mb-2 text-2xl sm:text-3xl font-bold text-blue-dark">Inicio de sesión</h2>
      <p class="text-sm text-gray-800 mt-4">Los campos marcados con * son obligatorios</p>
    </div>
    <LogInForm/>
    <p v-if="showUserRegistration" class="w-full mt-5 pt-5 border-t text-sm">
      ¿No tiene cuenta?
      <router-link to="/signup" class="text-blue-dark underline font-bold ml-1">Regístrese aquí</router-link>
    </p>
  </div>
</template>

<script>
import LogInForm from '@/components/Login/LogInForm'
export default {
  data() {
        return {
          showUserRegistration: true
        };
  },    
  created() { 
    if(process.env.VUE_APP_SHOW_USER_REGISTRATION &&
      process.env.VUE_APP_SHOW_USER_REGISTRATION === 'false') {
        this.showUserRegistration = false;
    }
  },  
  components: {
    LogInForm
  },
  methods: {
    switchLocale() {
      if(this.$i18n.locale === 'en'){
        this.$i18n.locale = 'es'
      }
      else {
        this.$i18n.locale = 'en'
      }
    }
  },
  computed: {
    displayLocale(){
      let locale = 'EN';
      if(this.$i18n.locale === 'es'){
        locale = 'ES'
      } else {
        locale = 'EN' 
      }
      return locale;
    }
  }
}
</script>